module.exports = __webpack_public_path__ + "img/artillery-wagon-base-6.5cbc5a7f.png";